import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";
import {
    selectSignalsById,
    selectSignalsDescription,
} from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";
import type { ComponentType } from "react";
import { useSelector } from "react-redux";

import type Signal from "../models/core/Signal";
import type SignalFilters from "../models/core/SignalFilters";

type ConsumerProps = {
    onCreateSuccess?<F extends SignalFilters>(signal: Signal<F>): void;
    onUpdateSuccess?<F extends SignalFilters>(signal: Signal<F>): void;
};

export default function withTrackedSignalView<P extends ConsumerProps>(Consumer: ComponentType<P>): ComponentType<P> {
    return function WrappedWithTrackedSignalView(props: P) {
        const signalsById = useSelector(selectSignalsById);
        const signalsDescription = useSelector(selectSignalsDescription);

        const handleTrackedSignalCreateSuccess = <F extends SignalFilters>(signal: Signal<F>) => {
            if (typeof props.onCreateSuccess === "function") {
                trackingService.management.trackCreateSignalEvent(signal, signalsDescription);
                props.onCreateSuccess(signal);
            }
        };

        const handleTrackedSignalUpdateSuccess = <F extends SignalFilters>(updatedSignal: Signal<F>) => {
            if (typeof props.onUpdateSuccess === "function") {
                trackingService.management.trackEditSignalEvent(
                    updatedSignal,
                    signalsById[updatedSignal.id],
                    signalsDescription,
                );
                props.onUpdateSuccess(updatedSignal);
            }
        };

        return (
            <Consumer
                {...(props as unknown as P)}
                onCreateSuccess={handleTrackedSignalCreateSuccess}
                onUpdateSuccess={handleTrackedSignalUpdateSuccess}
            />
        );
    };
}
